import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    color: {
      bgColor: "#f4a261",
      textColor: "#000",
    },
  },
  mutations: {
    SET_COLOR: (state, payload) => {
      state.color = payload;
    },
  },
  getters: {
    getColor: (state) => state.color,
  },
  actions: {
    updateColor(context, payload) {
      context.commit("SET_COLOR", payload);
    },
  },
  modules: {},
});
